import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'

export enum SponsorType {
  Federal = 'Federal',
  Industry = 'Industry',
  NonProfitFoundation = 'NonProfitFoundation',
  ExternalOther = 'ExternalOther',
  InstitutionalSupport = 'InstitutionalSupport',
  Other = 'Other',
}
// Needs to be before namespace is defined
const SPONSOR_TYPES: ReadonlySet<SponsorType> = new Set(
  Object.values(SponsorType) as SponsorType[],
)
export namespace SponsorType {
  export const ALL: readonly SponsorType[] = Array.from(SPONSOR_TYPES)
  export const isSponsorType = TypeChecker.Factory.oneOf(SPONSOR_TYPES)
  export const assertIsSponsorType: TypeAsserter<SponsorType> =
    TypeAsserter.Factory.from(isSponsorType)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link SponsorType}
   */
  export function getEntry(
    sponsorType: SponsorType,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[sponsorType], id: sponsorType }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    SponsorType,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [SponsorType.Federal]: {
      name: 'Federal',
    },
    [SponsorType.Industry]: {
      name: 'Industry',
    },
    [SponsorType.NonProfitFoundation]: {
      name: 'Non-Profit Foundation',
    },
    [SponsorType.ExternalOther]: {
      name: 'External Other',
    },
    [SponsorType.InstitutionalSupport]: {
      name: 'Institutional Support',
    },
    [SponsorType.Other]: {
      name: 'Other',
    },
  }
}
